import React, { useEffect } from 'react'
import MultiSelectionDrp from '../../../../../components/MultiSelectionDrp'
import { useSelector } from 'react-redux'
import CustomValuesHook from '../../../../../Hooks/customValuesHook'
import { ContactCategory } from '../../../../../service/interfaces/contacts'
import { CheckSvg, CloseSVG, PlusSVG, UncheckSvg } from '../../../../../components/IconSvg'
import AddContactCategory from './addContactCategory'
import { useDispatch } from 'react-redux'
import { SetSelectedContactCategoryAction } from '../../../../../service/actions/contactActions'

const ContactCategories = () => {
    const contactCategories = useSelector((state: any) => state.contactReducer.contactCategories)
    const [states, setStates] = CustomValuesHook({ selectedItem: null, displayAddModal: false })
    const dispatch = useDispatch()

    useEffect(() => {

        // selectContactCategory(states.selectedItems.map((item: ContactCategory) => item.id))
        dispatch(SetSelectedContactCategoryAction(states.selectedItem))
    }, [states.selectedItem])

    const itemComponent = ({ item, idx, itemClickHandler, selectedList }: any) => {
        return (
            <div>{item.name}</div>
        )
    }
    const handleSelectItem = (item: ContactCategory | null) => {
        setStates({ selectedItem: item ? { ...item } : null })

    }
    const selectedItemsComponent = (selectedList: ContactCategory, itemClickHandler: Function) => {
        return (<div className='d-flex align-items-center pt-1'>
            <span >{selectedList?.name ? selectedList?.name : 'دسته‌بندی مخاطب'} </span>
            {selectedList?.name && <span className='remove-selected-spn'
                onClick={(e) => {
                    e.stopPropagation()
                    if (typeof itemClickHandler === 'function') {
                        itemClickHandler(null)
                        dispatch(SetSelectedContactCategoryAction(null));
                    }

                }} >
                <CloseSVG fill='red' />
            </span>}
        </div>)
    }


    const bottomTool = () => {

        return (<div className='p-2'>
            <span className='bottom-add-btn' onClick={() => setStates({ displayAddModal: true })}>دسته‌بندی جدید
                <PlusSVG fill='#ffffff' />
            </span>
        </div>)
    }
    return (
        <div>
            <MultiSelectionDrp
                itemClickHandler={handleSelectItem}
                itemComponent={itemComponent}
                selectedItemsComponent={selectedItemsComponent}
                list={contactCategories?.data ? contactCategories?.data : []}
                selectedList={states.selectedItem}
                bottomTool={bottomTool}
                isMultiSelect={false}

            />
            <AddContactCategory display={states.displayAddModal} setDisplay={() => { setStates({ displayAddModal: false }) }} />
        </div>
    )
}

export default ContactCategories